var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{class:['form-control', _vm.className],attrs:{"name":_vm.name,"multiple":_vm.multiple}})}
var staticRenderFns = []

export { render, staticRenderFns }